import React, { useContext, useMemo } from 'react';
import Tabs from '../../Tabs/Tabs';

import AssetList from '../AssetList/AssetList';
import { useTranslation } from '../../../localization/useTranslation';
import NodeContext from '../../../services/Context/NodeContext';
import Icons, { Size } from '../../Common/Icons';
import './NodeView.css';
import dashboardTabs from './dashboardTabs';

const NodeView = ({ assetIds, dashboards }) => {
  const nodeContext = useContext(NodeContext);
  const T = useTranslation();

  const tabs = useMemo(() => {
    return [
      ...dashboardTabs(dashboards),
      {
        label: T.common.assets,
        icon: <Icons.Asset size={Size.SMALL}/>,
        component: AssetList,
        props: {
          assetIds,
          baseUrl: nodeContext?.baseUrl
        }
      }
    ];
  }, [dashboards, T.common.assets, assetIds, nodeContext?.baseUrl]);
  return (
    <div className={'node-main'}>
      <Tabs tabs={tabs} />
    </div>
  );
};

export default React.memo(NodeView);
